module.exports = __webpack_public_path__ + "static/media/pdp_foilSilverHover.9e3021ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/pdp-hover/pdp_foilSilverHover.jpg
// module id = 1193
// module chunks = 68